import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useRooms } from "@/data/rooms";
import { MaskLines, Reveal } from "@/components/MaskLines";
import { useLang } from "@/lib/i18n";

export default function Rooms() {
  const { t } = useLang();
  const rooms = useRooms();
  return (
    <main className="mx-auto max-w-[1440px] px-5 pb-24 pt-32 md:px-10" data-testid="rooms-page">
      <p className="mono text-xs text-[var(--brick-light)]">{t("rooms.kicker")}</p>
      <MaskLines as="h1" className="mt-4 font-display text-5xl leading-[0.95] sm:text-6xl lg:text-8xl" lines={[t("rooms.l1"), <em key="s">{t("rooms.l2")}</em>]} />
      <div className="mt-16">
        {rooms.map((r) => (
          <Reveal key={r.id}>
            <Link to={`/salas/${r.id}`} className="group grid items-center gap-6 border-t border-white/10 py-10 md:grid-cols-12" data-testid={`room-row-${r.id}`}>
              <span className="mono text-xs md:col-span-1" style={{ color: r.color }}>{r.num}</span>
              <div className="md:col-span-5">
                <h2 className="font-display text-5xl leading-none transition-transform duration-700 group-hover:translate-x-3 lg:text-7xl">{r.name}</h2>
                <p className="mt-2 font-display text-2xl italic" style={{ color: r.color }}>{r.title}</p>
              </div>
              <p className="text-sm leading-relaxed text-[var(--muted)] md:col-span-3">{r.summary}<span className="mono mt-3 block text-[11px]">{r.dims} · {r.area} m²</span></p>
              <div className="flex items-center justify-between gap-6 md:col-span-3">
                <div className="arch-frame aspect-[3/4] w-28 md:w-32"><img src={r.img} alt={r.name} className="h-full w-full object-cover" /></div>
                <span className="grid h-12 w-12 place-items-center rounded-full border border-white/25 transition-all duration-500 group-hover:rotate-45 group-hover:bg-[var(--ink)] group-hover:text-[var(--bg)]"><ArrowUpRight size={18} /></span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </main>
  );
}
